/**
 * Bookmarks to /rfp/desk-settings land on Organic Content with the settings panel open.
 */

import { useEffect } from 'react';
import { useAuthContext, useWorkspace } from '@tracekit/core';
import { isSparcTenant, ORGANIC_CONTENT_PATH } from './organicContentModel';

export function OrganicDeskSettingsPage() {
  const { tenantId } = useWorkspace();
  const { isAuthenticated } = useAuthContext();
  const sparcOk = isSparcTenant(tenantId);

  useEffect(() => {
    if (!sparcOk || !isAuthenticated) return;
    const next = `${ORGANIC_CONTENT_PATH}?settings=1`;
    window.location.replace(next);
  }, [sparcOk, isAuthenticated]);

  if (!sparcOk) {
    return (
      <div
        className="flex h-full items-center justify-center bg-white p-8 text-center text-slate-600"
        data-testid="organic-desk-settings-gated"
      >
        Organic settings are available for the SPARC GovEarner tenant only.
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div className="flex h-full items-center justify-center bg-white p-8 text-center text-sm text-slate-500">
        Sign in to open Organic settings.
      </div>
    );
  }

  return (
    <div className="flex h-full items-center justify-center bg-white p-8 text-sm text-slate-500" data-testid="organic-desk-settings-page">
      Opening Organic settings…
    </div>
  );
}

export function OrganicDeskSettingsRoute() {
  return (
    <div className="h-full min-h-0 w-full bg-white" data-testid="organic-desk-settings-route">
      <OrganicDeskSettingsPage />
    </div>
  );
}

export default OrganicDeskSettingsRoute;
